import { Alert } from 'react-native';
import { clearPrivateJobSubmissionDrafts } from '../../vrs-auth/privateJobSubmissionDrafts';
import { mobileLog } from './logging';
/** Start before clearing/replacing auth; do not hold sign-out or sign-in open. */
export function beginPrivateJobDraftCleanup() {
    let reported = false;
    const report = () => {
        if (reported)
            return;
        reported = true;
        mobileLog('warn', 'interpreter_jobs_private_draft_cleanup_failed', {});
        try {
            Alert.alert('Private draft cleanup incomplete', 'This device could not confirm removal of earlier Jobs draft details. Your account change will continue. Jobs recovery remains limited to the original account.');
        }
        catch {
            mobileLog('warn', 'interpreter_jobs_private_draft_cleanup_notice_failed', {});
        }
    };
    const timer = setTimeout(report, 15000);
    void clearPrivateJobSubmissionDrafts().then(() => clearTimeout(timer), () => { clearTimeout(timer); report(); });
}
